import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { StepIconProps } from "@mui/material/StepIcon";
import BadgeIcon from "@mui/icons-material/Badge";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import VerifiedIcon from "@mui/icons-material/Verified";
import { styled } from "@mui/material/styles";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import EditIcon from "@mui/icons-material/Edit";
import PaymentsIcon from "@mui/icons-material/Payments";
import DesignSpecifications from "../../pages/designSpecifications/designSpecifications";
import CompleteInfo from "../../pages/completeInfo/completeInfo";
import RegisterNewRequest from "../../pages/requests/requests";
import FacilityApproval from "../../pages/facilityApproval/facilityApproval";
import Grid from "@mui/material/Grid";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useHistory, withRouter } from "react-router-dom";
import { HandleNext } from "../../models/sharedFunctions";
import {
  IS_EDITABLE,
  IS_CANCELABLE,
  REFERENCE_KEY,
  CANCELLOAN_REQUEST,
  NATIONAL_CODE,
} from "../../config/cacheKey";
import { useMutation, useQuery, useQueryClient } from "react-query";
import CustomerRegistrationInfo from "../../hook";
import Confirmation from "../../pages/completeInfo/confirmation";
import ModalCancelLoan from "../modals/ModalCancelLoan";
import { getCustomerRegistrationInfo } from "../../services/loan.service";
import { connect, useDispatch } from "react-redux";
import { useEffect } from "react";
import { decrement, increment } from "../../redux/activeStep/activeStepSlice";
import { setStep } from "../../redux/activeStep/activeStepAction";
// import Payments from './svg/payments_black.svg';

let setlineColor = "";
let setTitleColor = "";
let isActive = true;
let activeButFirstStep = true;
let activeIconFirstStep = "none";
const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
    left: "calc(50% + 16px)",
    right: "calc(-50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      border: "1px solid #01AF43",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      border: "1px solid #01AF43",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")<{
  ownerState: { completed?: boolean; active?: boolean };
}>(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#fff",
  border: "2px solid #C1C7CB",
  zIndex: 1,
  color: "#C1C7CB",
  width: 40,
  height: 40,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    border: "2px solid #01AF43",
    backgroundColor: "#fff",
    color: "#1D4A87",
  }),
  ...(ownerState.completed && {
    border: "2px solid #01AF43",
    backgroundColor: "#01AF43",
    color: "#fff",
  }),
}));

function ColorlibStepIcon(props: StepIconProps) {
  const { active, completed, className } = props;
  const icons: { [index: string]: React.ReactElement } = {
    1: <BadgeIcon className="iconStyle" />,
    2: <PaymentsIcon className="iconStyle" />,
    3: <EditIcon className="iconStyle" />,
    4: <FactCheckIcon className="iconStyle" />,
    5: <VerifiedIcon className="iconStyle" />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

const steps = [
  "ثبت کد ملی متقاضی",
  " انتخاب طرح ",
  "استعلام و تشکیل پرونده ",
  "تایید اطلاعات ",
  "فعالسازی تسهیلات",
];
function _renderStepContent(step: number, { handleNext }: HandleNext) {
  switch (step) {
    case 0:
      return <RegisterNewRequest handleNext={handleNext} />;
    case 1:
      return <DesignSpecifications handleNext={handleNext} />;
    case 2:
      return <CompleteInfo handleNext={handleNext} />;
    case 3:
      return <FacilityApproval handleNext={handleNext} />;
    case 4:
      return <Confirmation handleNext={handleNext} />;
  }
}

function StepperCMP({ step }: StepperCMPPropsInterface) {

  const dispatch = useDispatch();
  // const [activeStep, setActiveStep] = React.useState(0);
  // const [skipped, setSkipped] = React.useState(new Set<number>());
  const queryClient = useQueryClient();
  const refrenceKey = queryClient.getQueryData<string>(REFERENCE_KEY);
  const isEditable = queryClient.getQueryData(IS_EDITABLE);
  let isCancelable = queryClient.getQueryData<boolean>(IS_CANCELABLE);

  const apiCall = () => {
    CustomerRegistrationInfo("2980131512");
  };
  const isStepSkipped = (step: number) => {
    // return skipped.has(step);
  };
  const history = useHistory();
  function indexPage() {
    history.push("/loan/SupplierSettlementCartable");
    // history.push("/loan/loan-list");
  }
  const handleNext = () => {
    // let newSkipped = skipped;
    getCustomerRegistrationInfo({
      nationalCode: queryClient.getQueryData<string>(NATIONAL_CODE),
    }).then((data) => {
      if (data.isEditable === false) {
        dispatch(setStep({ step: 4 }))
        // apiCall();
      } else {
        dispatch(increment())
        // setSkipped(newSkipped);
      }
    });
  };

  const handleBack = () => {
    // setActiveStep((prevActiveStep: number) => prevActiveStep - 1);
    dispatch(decrement())
  };

  const handleSkip = () => {
    // setActiveStep((prevActiveStep: number) => prevActiveStep - 1);
    dispatch(decrement())
    if (step.step == 0) {
      indexPage();
    }
    if (step.step == 4) {
      // setActiveStep(() => 0);
      dispatch(setStep({ step: 0 }))
    }

    if (step.step - 1 > 0) {
      activeIconFirstStep = "";
      activeButFirstStep = false;
    } else {
      activeIconFirstStep = "none";
      activeButFirstStep = true;
    }
  };

  const handleReset = () => {
    // setActiveStep(0);
  };

  return (
    <Box sx={{ width: "100%", margin: "auto" }}>
      <div className="gridHeaderStepper">
        <Grid container spacing={3}>
          <Grid item xs="auto">
            <span
              color="inherit"
              onClick={handleSkip}
              className=" colorTitle cursorPointer textFont14 fontTitle"
            >
              بازگشت
            </span>
            <ChevronRightIcon />
          </Grid>
          {/* <Grid item xs="auto" style={{ display: activeIconFirstStep }}>
            <span className="line"> </span>
          </Grid> */}
          <Grid item xs="auto">
            <span
              hidden={!isCancelable || step.step === 0}
              className=" colorRed cursorPointer textFont14 fontTitle"
            >
              {" "}
              <ModalCancelLoan />
            </span>
          </Grid>
        </Grid>
      </div>
      <div className="horizontalLine"></div>
      <div className="mTop20" style={{ width: "98%", margin: "auto" }}>
        <span
          className="colorTitle fontWeight textFont16 mbottom10"
          style={{
            marginTop: "-10px",
            position: "absolute",
            marginRight: "20px",
            background: "#fff",
            paddingRight: '5px',
            paddingLeft: '5px'
          }}
        >
          {" "}
          ثبت درخواست تسهیلات
        </span>
        <div className="cardBorder borderCOlor">
          <Box sx={{ margin: "auto" }} className="col-lg-6">
            <Stepper
              activeStep={step.step}
              alternativeLabel
              connector={<ColorlibConnector />}
            >
              {steps.map((label, index) => {
                const stepProps: { completed?: boolean } = {};
                const labelProps: {
                  optional?: React.ReactNode;
                } = {};
                {
                  step.step >= index
                    ? (setlineColor = "lineStepper")
                    : (setlineColor = "inactivelineStepper");
                }
                if (step.step == index) {
                  setTitleColor = "titleStepper";
                } else if (step.step > index) {
                  setTitleColor = "titleCompleteStepper";
                } else {
                  setTitleColor = "titleInactiveStepper";
                }
                // if (activeStep + 1 === steps.length) {
                //   isActive = false;
                // } else {
                //   isActive = true;
                // }

                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel
                      style={{ flexShrink: 1 }}
                      StepIconComponent={ColorlibStepIcon}
                      {...labelProps}
                    >
                      <div className={setlineColor}></div>
                      <span className={setTitleColor}>{label}</span>
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </Box>
        </div>
      </div>
      {
        <React.Fragment>
          {_renderStepContent(step.step, { handleNext })}
          {/* <Box sx={{ display: "flex", flexDirection: "row", pt: 2, paddingLeft: '1%' }}>
            <Box sx={{ flex: "1 1 auto" }} />
            {isActive &&
              <Button
                onClick={handleNext}
                className="textFont14 fontTitle SuccessDefault buttonColor buttonStepper"
              >
                ادامه
              </Button>}
          </Box> */}
        </React.Fragment>
      }
    </Box>
  );
}

interface StepperCMPPropsInterface {
  step: any;
}
const mapStateToProps = ({ step }: StepperCMPPropsInterface) => {
  return { step };
};

export default withRouter(connect(mapStateToProps)(StepperCMP));
